<template>
  <div class="clearfix mt3">
    <form @submit="onSubmitPurchaseInfo" @reset="resetForm">
      <fieldset>
        <div class="clearfix flex flex-column">
          <div v-for="packageOption in packageOptions" :key="packageOption.id">
            <div :for="packageOption.id" class="flex justify-start items-start mb3">
              <div>
                <template>
                  <div v-if="packageOption.id == '1'" class="flex-auto">
                    <span class="mediumgrey">
                      <svg fill="currentColor" width="64" height="64" viewBox="0 0 496 496" xmlns="http://www.w3.org/2000/svg"><path d="m224 176c13.230469 0 24-10.769531 24-24s-10.769531-24-24-24-24 10.769531-24 24 10.769531 24 24 24zm0-32c4.414062 0 8 3.585938 8 8s-3.585938 8-8 8-8-3.585938-8-8 3.585938-8 8-8zm0 0"/><path d="m488 240h-40v-40c0-4.425781-3.574219-8-8-8h-40v-40c0-4.425781-3.574219-8-8-8h-40v-40c0-4.425781-3.574219-8-8-8h-185.617188c1.058594-5.167969 1.617188-10.519531 1.617188-16 0-44.113281-35.886719-80-80-80s-80 35.886719-80 80 35.886719 80 80 80c5.480469 0 10.832031-.558594 16-1.617188v185.617188c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h240c4.425781 0 8-3.574219 8-8v-240c0-4.425781-3.574219-8-8-8zm-293.625 16h-68.75l34.375-29.464844zm-5.382812-25.679688 19.007812-19.007812 21.9375 21.933594-18.21875 16.5625zm106.742187-35.273437 40.265625 40.265625v20.6875h-107.304688zm-279.734375-115.046875c0-35.289062 28.710938-64 64-64s64 28.710938 64 64-28.710938 64-64 64-64-28.710938-64-64zm137.273438 32h182.726562v100.6875l-34.34375-34.34375c-3.015625-3.023438-7.878906-3.136719-11.039062-.265625l-48.832032 44.394531-28.128906-28.128906c-3.128906-3.128906-8.183594-3.128906-11.3125 0l-25.535156 25.535156-11.609375-9.949218c-2.984375-2.578126-7.421875-2.578126-10.40625 0l-42.792969 36.6875v-93.34375c18.40625-8.074219 33.199219-22.867188 41.273438-41.273438zm-41.273438 160h224v64h-224zm48 80h184c4.425781 0 8-3.574219 8-8v-184h32v224h-224zm48 48h184c4.425781 0 8-3.574219 8-8v-184h32v224h-224zm272 80h-224v-32h184c4.425781 0 8-3.574219 8-8v-184h32zm0 0"/><path d="m128 88v-16h-40v-40h-16v40h-40v16h40v40h16v-40zm0 0"/></svg>
                    </span>
                  </div>
                  <div v-if="packageOption.id == '2'" class="flex-auto">
                    <span class="mintgreen">
                      <svg fill="currentColor" width="64" height="64" viewBox="0 0 496 496" xmlns="http://www.w3.org/2000/svg"><path d="m224 176c13.230469 0 24-10.769531 24-24s-10.769531-24-24-24-24 10.769531-24 24 10.769531 24 24 24zm0-32c4.414062 0 8 3.585938 8 8s-3.585938 8-8 8-8-3.585938-8-8 3.585938-8 8-8zm0 0"/><path d="m488 240h-40v-40c0-4.425781-3.574219-8-8-8h-40v-40c0-4.425781-3.574219-8-8-8h-40v-40c0-4.425781-3.574219-8-8-8h-185.617188c1.058594-5.167969 1.617188-10.519531 1.617188-16 0-44.113281-35.886719-80-80-80s-80 35.886719-80 80 35.886719 80 80 80c5.480469 0 10.832031-.558594 16-1.617188v185.617188c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h240c4.425781 0 8-3.574219 8-8v-240c0-4.425781-3.574219-8-8-8zm-293.625 16h-68.75l34.375-29.464844zm-5.382812-25.679688 19.007812-19.007812 21.9375 21.933594-18.21875 16.5625zm106.742187-35.273437 40.265625 40.265625v20.6875h-107.304688zm-279.734375-115.046875c0-35.289062 28.710938-64 64-64s64 28.710938 64 64-28.710938 64-64 64-64-28.710938-64-64zm137.273438 32h182.726562v100.6875l-34.34375-34.34375c-3.015625-3.023438-7.878906-3.136719-11.039062-.265625l-48.832032 44.394531-28.128906-28.128906c-3.128906-3.128906-8.183594-3.128906-11.3125 0l-25.535156 25.535156-11.609375-9.949218c-2.984375-2.578126-7.421875-2.578126-10.40625 0l-42.792969 36.6875v-93.34375c18.40625-8.074219 33.199219-22.867188 41.273438-41.273438zm-41.273438 160h224v64h-224zm48 80h184c4.425781 0 8-3.574219 8-8v-184h32v224h-224zm48 48h184c4.425781 0 8-3.574219 8-8v-184h32v224h-224zm272 80h-224v-32h184c4.425781 0 8-3.574219 8-8v-184h32zm0 0"/><path d="m128 88v-16h-40v-40h-16v40h-40v16h40v40h16v-40zm0 0"/></svg>
                    </span>
                  </div>
                  <div v-if="packageOption.id == '3'" class="flex-auto">
                    <span class="primarycolor">
                      <svg fill="currentColor" width="64" height="64" viewBox="0 0 496 496" xmlns="http://www.w3.org/2000/svg"><path d="m224 176c13.230469 0 24-10.769531 24-24s-10.769531-24-24-24-24 10.769531-24 24 10.769531 24 24 24zm0-32c4.414062 0 8 3.585938 8 8s-3.585938 8-8 8-8-3.585938-8-8 3.585938-8 8-8zm0 0"/><path d="m488 240h-40v-40c0-4.425781-3.574219-8-8-8h-40v-40c0-4.425781-3.574219-8-8-8h-40v-40c0-4.425781-3.574219-8-8-8h-185.617188c1.058594-5.167969 1.617188-10.519531 1.617188-16 0-44.113281-35.886719-80-80-80s-80 35.886719-80 80 35.886719 80 80 80c5.480469 0 10.832031-.558594 16-1.617188v185.617188c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h240c4.425781 0 8-3.574219 8-8v-240c0-4.425781-3.574219-8-8-8zm-293.625 16h-68.75l34.375-29.464844zm-5.382812-25.679688 19.007812-19.007812 21.9375 21.933594-18.21875 16.5625zm106.742187-35.273437 40.265625 40.265625v20.6875h-107.304688zm-279.734375-115.046875c0-35.289062 28.710938-64 64-64s64 28.710938 64 64-28.710938 64-64 64-64-28.710938-64-64zm137.273438 32h182.726562v100.6875l-34.34375-34.34375c-3.015625-3.023438-7.878906-3.136719-11.039062-.265625l-48.832032 44.394531-28.128906-28.128906c-3.128906-3.128906-8.183594-3.128906-11.3125 0l-25.535156 25.535156-11.609375-9.949218c-2.984375-2.578126-7.421875-2.578126-10.40625 0l-42.792969 36.6875v-93.34375c18.40625-8.074219 33.199219-22.867188 41.273438-41.273438zm-41.273438 160h224v64h-224zm48 80h184c4.425781 0 8-3.574219 8-8v-184h32v224h-224zm48 48h184c4.425781 0 8-3.574219 8-8v-184h32v224h-224zm272 80h-224v-32h184c4.425781 0 8-3.574219 8-8v-184h32zm0 0"/><path d="m128 88v-16h-40v-40h-16v40h-40v16h40v40h16v-40zm0 0"/></svg>
                    </span>
                  </div>
                </template>
              </div>
              <div class="px2">
                <p class="h6 semi-bold darkblue gibson line-height-2">
                  {{packageOption.productname}}
                </p>
                <p class="h6 regular darkblue gibson line-height-4 flex justify-start items-center">
                  <span class="relative mr1" style="top:4px;">
                    <input type="radio" :id="packageOption.id" :value="packageOption.id" class="radion_select mr-1" v-model="picked">
                  </span>
                  <span>{{packageOption.total}} kr.</span>
                </p>
              </div>
              <p class="h6 darkblue gibson line-height-3 regular">
                {{packageOption.description}}
              </p>
            </div>
          </div>
        </div>
        <div class="clearfix">
          <button class="col-12 border-none not-rounded standard-button p2 h5 gibson flex justify-center items-center" type="submit">
            <span class="mr1">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-credit-card-f"><path d='M20 4H0V2a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2zm0 3v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7h20zM4 9a1 1 0 1 0 0 2h1a1 1 0 0 0 0-2H4zm5 0a1 1 0 1 0 0 2h5a1 1 0 0 0 0-2H9z' /></svg>
            </span>
            <span class="regular">Køb projekt</span>
          </button>
        </div>
      </fieldset>
      <loading :show="show" :label="label" :overlay="overlay"></loading>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </form>
    <div class="clearfix mt4 mb2">
      <p class="h4 primarycolor gibson">
        Dine købte projekter
      </p>
    </div>
    <div class="clearfix">
      <div v-for="item in items" class="flex flex-column p3 py4 muted-background mb3 shadow">
        <div>
          <p class="h6 darkblue regular line-height-1 mb1">Produkt</p>
          <p class="semi-bold gibson h5 line-height-3">{{item.productname}}</p>
          <div class="py1"></div>
          <p class="h6 darkblue regular line-height-1 mb1">Købsdato</p>
          <p class="semi-bold gibson h5 line-height-3">{{moment(item.timeinvoice).locale('da').format('LL')}}</p>
          <div class="py1"></div>
          <p class="h6 darkblue regular line-height-1 mb1">Status</p>
          <p class="semi-bold gibson h5 line-height-3">{{item.status}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import loading from 'vue-full-loading'
  import Simplert from 'vue2-simplert'
  export default {
    name: 'purchase',
    components: {
      loading,
      Simplert
    },
    data () {
      return {
        selected: '',
        creditCard: 'Dankort',
        show: false,
        label: 'Loading...',
        picked: '',
        visiblecredit: 0,
        overlay: true,
        salesPerson: '',
        packageOptions: [ ],
        tableFields: [
          { key: 'productname', label: 'Pakke' },
          { key: 'timeinvoice', label: 'Dato' },
          { key: 'status', label: 'Status' }
        ],
        items: [
        ]
      }
    },
    created () {
      this.Reload()
    },
    methods: {
      Reload () {
        this.salesPerson = localStorage.getItem('id_token_portal')
        this.haaId = localStorage.getItem('haaid')
        var data = {operation: 'mykoebInfo', salesPerson: this.salesPerson, levid: this.haaId}
        this.$http.post('', data, { emulateJSON: true })
          .then(
            response => {
              var res = response.body
              if (res.login === false) {
                this.$router.push('/login')
              }
              this.packageOptions = res.package
              this.items = res.sale
              this.visiblecredit = res.visiblecredit
              console.log(res)
            },
            response => {
              alert('error')
            }
          )
      },
      onSubmitPurchaseInfo (evt) {
        evt.preventDefault()
        if (this.picked === '') {
          let obj = {
            title: 'Fejl',
            message: 'Vælg Pakke',
            type: 'error'
          }
          this.$refs.simplert.openSimplert(obj)
          return false
        }
        this.show = true
        this.salesPerson = localStorage.getItem('id_token_portal')
        this.haaId = localStorage.getItem('haaid')
        var data = { operation: 'addSale', salesPerson: this.salesPerson, levid: this.haaId, package: this.picked }
        this.$http.post('', data, { emulateJSON: true })
          .then(
            response => {
              this.show = false
              var res = response.body
              if (res.success) {
                let closeFn = function () {
                  this.$parent.Reload()
                  this.$parent.picked = ''
                }
                let obj = {
                  title: 'Gennemført!',
                  message: '',
                  type: 'success',
                  onClose: closeFn
                }
                this.$refs.simplert.openSimplert(obj)
              } else {
                let obj = {
                  title: 'Fejl',
                  message: 'Fejl - Kontakt venligst administrator',
                  type: 'error'
                }
                this.$refs.simplert.openSimplert(obj)
              }
            },
            response => {
              alert('error')
            }
          )
      },
      resetForm (evt) {
        evt.preventDefault()
        Object.assign(this.$data, this.$options.data.call(this))
      }
    }
  }
</script>
<style lang="less">
.purchaseTable {
  th {
    color: rgba(0, 54, 69, 1.0);
    font-weight: 400;
    padding-bottom: 0;
    padding-left: 0;
    font-family: 'canada-type-gibson';
  }
}
// .table thead th {
//   color: #999;
//   font-weight: 400!important;
//   padding-bottom: 0;
//   padding-left: 0;
// }
.table thead th,
.table th,
.table td {
  border-bottom: 0;
  border-top: 0;
  font-family: 'canada-type-gibson'!important;
  padding-left: 0;
  font-weight: 400!important;
}
.card-header {
  color: #000!important;
}
.radion_select {
  height: 20px;
  width: 20px;
}
</style>


// WEBPACK FOOTER //
// Koeb.vue?a0808446